import type { FC } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import MakeDataDrivenDecisionsImage from './MakeDataDrivenDecisionsImage'

const copy = {
  heading: `Make data driven decisions that can transform care management`,
}

const link = {
  text: `Explore Journeys`,
  url: `/product/twilio-engage/`,
}

const feature = [
  {
    head: `Build`,
    description: `Create personalized patient experiences with timely and impactful interactions across the care journey.`,
  },
  {
    head: `Engage`,
    description: `Leverage real-time customer Profiles to build Audiences based on patient or member data, and engage them on their preferred channel.`,
  },
  {
    head: `Transform`,
    description: `Give relevant context to every team in your organization, with data they can trust, and start a continuous conversation with customers.`,
  },
]

const MakeDataDrivenDecisions: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <StyledSectionBase variant="2Col">
      <SectionContents>
        <MakeDataDrivenDecisionsImage alt={`Illustration: ${copy.heading}`} />
      </SectionContents>
      <StyledCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <ColumnTrackWrapper>
            <ColumnTrack gap="small">
              {feature.map((feature) => (
                <FeatureBoxBase key={feature.head} alignment="left">
                  <FeatureBox.Body>
                    <FeatureBox.Title>{feature.head}</FeatureBox.Title>
                    <FeatureBox.Text>{feature.description} </FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </ColumnTrackWrapper>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </StyledCopy>
    </StyledSectionBase>
  )
}

export default MakeDataDrivenDecisions

const SectionContents = styled(Section.Contents)`
  margin: auto 0;
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    align-self: center;
  }
`

const ColumnTrackWrapper = styled.div`
  padding-top: 40px;
`
